// extracted by mini-css-extract-plugin
export default {"root":"SectionRulesMaybe_root__3HxpO","title":"SectionRulesMaybe_title__ivB9L h3","rules":"SectionRulesMaybe_rules__dM8pG"};